<div fxLayout="row wrap" #resizedDiv>
    <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" class="p-2"> 
        <mat-card class="p-0 gradient-purple">
            <div class="p-2" fxLayoutAlign="space-between center">
                <p class="mb-0">Locations sur 10 ans</p>
                <div fxLayoutAlign="center center">
                    <mat-icon class="icon-sm px-1">trending_up</mat-icon>
                    <span>{{nbLocation}}</span>
                </div>
            </div>         
            <div class="w-100 h-100p">
                <ngx-charts-line-chart
                    [scheme]="colorScheme"
                    [results]="locations"  
                    [autoScale]="autoScale"                    
                    (select)="onSelect($event)">
                </ngx-charts-line-chart>                   
            </div>
        </mat-card>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" class="p-2"> 
        <mat-card class="p-0 gradient-teal">
            <div class="p-2" fxLayoutAlign="space-between center">
                <p class="mb-0">Paiements sur 10 ans</p>
                <div fxLayoutAlign="center center">
                    <mat-icon class="icon-sm px-1">trending_up</mat-icon>
                    <span>{{nbPaiement}}</span>
                </div>
            </div>          
            <div class="w-100 h-100p">
                <ngx-charts-line-chart
                    [scheme]="colorScheme"
                    [results]="payment"                      
                    [autoScale]="autoScale"
                    (select)="onSelect($event)">
                </ngx-charts-line-chart>                  
            </div>
        </mat-card>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" class="p-2"> 
        <mat-card class="p-0 gradient-indigo">
            <div class="p-2" fxLayoutAlign="space-between center">
                <p class="mb-0">Utilisateurs ***</p>
                <div fxLayoutAlign="center center">
                    <mat-icon class="icon-sm px-1">trending_down</mat-icon>
                    <span>{{nbUser}}</span>
                </div>
            </div>          
            <div class="w-100 h-100p">
                <ngx-charts-line-chart
                    [scheme]="colorScheme"
                    [results]="users"                      
                    [autoScale]="autoScale"
                    (select)="onSelect($event)">
                </ngx-charts-line-chart>                  
            </div>
        </mat-card>
    </div>    
    <div fxFlex="100" fxFlex.gt-sm="25" fxFlex.sm="50" class="p-2"> 
        <mat-card class="p-0 gradient-amber">
            <div class="p-2" fxLayoutAlign="space-between center">
                <p class="mb-0">Véhicules ***</p>
                <div fxLayoutAlign="center center">
                    <mat-icon class="icon-sm px-1">trending_up</mat-icon>
                    <span>{{nbCar}}</span>
                </div>
            </div>         
            <div class="w-100 h-100p">
                <ngx-charts-line-chart
                    [scheme]="colorScheme"
                    [results]="cars"                      
                    [autoScale]="autoScale"
                    (select)="onSelect($event)">
                </ngx-charts-line-chart>                  
            </div>
        </mat-card>
    </div>    
</div>